<script setup lang="ts">
import { getAppEnvironment } from '@/environments'

const environment = getAppEnvironment()

const props = defineProps({
  data: {
    type: Array,
    required: true
  }
})

const columns = [
  {
    field: 'policyNumber',
    label: 'Policy'
  },
  {
    field: 'lastName',
    label: 'Last Name'
  },
  {
    field: 'firstName',
    label: 'First Name'
  },
  {
    field: 'emailAddress1',
    label: 'Email'
  },
  {
    field: 'telephone1',
    label: 'Phone #'
  },
  {
    field: 'addressLine1',
    label: 'Address'
  },
  {
    field: 'zip',
    label: 'Zip'
  },
  {
    field: 'city',
    label: 'City'
  },
  {
    field: 'state',
    label: 'State'
  },
  {
    field: 'additionalInsuredEmail',
    label: 'Additional Insured'
  }
]

const { data } = toRefs(props)

const handleClick = (event: Event) => {
  const target = event.target as HTMLElement
  target.style.color = '#673A89'
}
</script>

<template>
  <div class="2xl:overflow-visible overflow-auto relative">
    <UITable
      :columns="columns"
      :data="data"
      v-bind="$attrs"
    >
      <template #column-policyNumber="{ value, row }">
        <template v-if="row.quoteOrPolicy === 'Quote'">Use Quote</template>
        <template v-else-if="row.contactId">
          <nuxt-link
            :to="`${environment.crmPolicyUrl}${row.contactId}%7d`"
            class="link underline underline-offset-2 focus:outline-offset-4"
            target="_blank"
            @click="handleClick"
          >
            {{ value }}
          </nuxt-link>
        </template>
        <template v-else>
          {{ value }}
        </template>
      </template>
      <template #column-addressLine1="{ value, row }">
        <div>{{ value }}</div>
        <div v-if="row.addressLine2">{{ row.addressLine2 }}</div>
      </template>
      <template #column-additionalInsuredEmail="{ value, row }">
        <span class="font-medium">{{ value }}</span>
        <div
          v-if="row.additionalInsuredFullName"
          class="text-sm"
        >
          {{ row.additionalInsuredFullName }}
        </div>
      </template>
    </UITable>
  </div>
</template>

<style scoped>
.link {
  color: #343434; /* Default link color */
  text-decoration: underline;
}

.link:visited {
  @apply text-primary; /* Visited link color */
}
</style>
